'use strict';

class SideNav {
    constructor() {
        this.showButtonEl = document.querySelector('.js-menu-show');
        this.hideButtonEl = document.querySelector('.js-menu-hide');
        this.sideNavEl = document.querySelector('.js-side-nav');
        this.sideNavContainerEl = document.querySelector('.js-side-nav-container');

        this.showSideNav = this.showSideNav.bind(this);
        this.hideSideNav = this.hideSideNav.bind(this);
        this.blockClicks = this.blockClicks.bind(this);


        this.sideNavEl.inert = true;

        this.previousActiveElement = undefined;

        this.addEventListeners();
    }

    addEventListeners() {
        this.showButtonEl.addEventListener('click', this.showSideNav);
        this.hideButtonEl.addEventListener('click', this.hideSideNav);
        this.sideNavEl.addEventListener('click', this.hideSideNav);
        this.sideNavContainerEl.addEventListener('click', this.blockClicks);
    }

    blockClicks(evt) {
        evt.stopPropagation();
    }

    showSideNav(e) {

        this.sideNavEl.inert = false;

        setTimeout(() => {
            this.hideButtonEl.focus();
        }, 1);
        
        document.querySelector('.page').inert = true;
        this.previousActiveElement = e.target;        
        this.sideNavEl.classList.add('side-nav--animatable');
        this.sideNavEl.classList.add('side-nav--visible');
        document.body.style.marginRight = `${(window.innerWidth - document.body.clientWidth)}px`;
        document.body.classList.add('noscroll');
    }

    hideSideNav() {
        document.querySelector('.page').inert = false;
        this.sideNavEl.inert = true;

        setTimeout(() => {
            this.previousActiveElement.focus();
        }, 1);
                
        this.sideNavEl.classList.add('side-nav--animatable');
        this.sideNavEl.classList.remove('side-nav--visible');
        document.body.classList.remove('noscroll');
        document.body.style.marginRight = null;
    }
}

document.addEventListener("DOMContentLoaded", function () {
    new SideNav();    
});




// WEBPACK FOOTER //
// ./Components/Navigation/side-nav.js